import { render, staticRenderFns } from "./UserPdf.vue?vue&type=template&id=2b5d717c&scoped=true"
import script from "./UserPdf.vue?vue&type=script&lang=js"
export * from "./UserPdf.vue?vue&type=script&lang=js"
import style0 from "./UserPdf.vue?vue&type=style&index=0&id=2b5d717c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d717c",
  null
  
)

export default component.exports